import { render, staticRenderFns } from "./folderTree.vue?vue&type=template&id=48ba9480&scoped=true"
import script from "./folderTree.vue?vue&type=script&lang=js"
export * from "./folderTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba9480",
  null
  
)

export default component.exports